import React, {Suspense} from 'react';
import {Route, Routes} from 'react-router-dom';
import {LoadingSpinner} from '@shared/components/ui/LoadingSpinner';
import {ROUTES} from './routes';

const EntitiesPage = React.lazy(() => import('@features/entities/pages/CasinosPage').then(m => ({default: m.CasinosPage})));
const EntityDetailsPage = React.lazy(() => import('@features/entities/pages/CasinoDetailsPage').then(m => ({default: m.CasinoDetailsPage})));
const NotFoundPage = React.lazy(() => import('@pages/NotFoundPage').then(m => ({default: m.NotFoundPage})));

export const AppRouter: React.FC = () => {
    return (
        <Suspense fallback={<LoadingSpinner text="Loading..."/>}>
            <Routes>
                <Route path={ROUTES.CASINOS} element={<EntitiesPage/>}/>
                <Route path={ROUTES.CASINO_DETAILS} element={<EntityDetailsPage/>}/>
                <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage/>}/>
            </Routes>
        </Suspense>
    );
};
